import { render, staticRenderFns } from "./reviewdetails.vue?vue&type=template&id=c662f814&scoped=true&"
import script from "./reviewdetails.vue?vue&type=script&lang=js&"
export * from "./reviewdetails.vue?vue&type=script&lang=js&"
import style0 from "./reviewdetails.vue?vue&type=style&index=0&id=c662f814&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c662f814",
  null
  
)

export default component.exports